import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GLOBAL_CSS, C } from "./data";
import Sidebar from "./components/Sidebar";
import Home from "./pages/Home";
import About from "./pages/About";
import Skills from "./pages/Skills";
import Projects from "./pages/Projects";
import Certifications from "./pages/Certifications";
import Contact from "./pages/Contact";

function Layout() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = GLOBAL_CSS;
    document.head.appendChild(style);
  }, []);

  return (
    <div style={{ background: C.bg, minHeight: "100vh", color: C.text }}>
      <Sidebar open={open} setOpen={setOpen} />

      {/* Main Content */}
      <main style={{ minHeight: "100vh" }}>
        <Routes>
          <Route path="/"                element={<Home />} />
          <Route path="/about"           element={<About />} />
          <Route path="/skills"          element={<Skills />} />
          <Route path="/projects"        element={<Projects />} />
          <Route path="/certifications"  element={<Certifications />} />
          <Route path="/contact"         element={<Contact />} />
        </Routes>
      </main>

      {/* Footer */}
      <footer style={{
        textAlign: "center", padding: "1.5rem",
        borderTop: `1px solid ${C.cardBorder}`,
        fontFamily: "'IBM Plex Mono', monospace",
        color: C.faint, fontSize: "0.7rem", letterSpacing: "2px",
      }}>
        © {new Date().getFullYear()} — Portofolio Raka Adi Waluyo
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
